import "../../global.css";
import "./categoryList.css";
import * as React from "react";
import { useState, useEffect, useMemo } from "react";
import { userRequest } from "../../requestMethods";
import { useSelector } from "react-redux";
import Button from "@mui/material/Button";
import SaveIcon from "@mui/icons-material/Save";
import { useCompany } from "../../components/context/CompanyContext";
import Loading from "../../components/loading/loading";
import IconButton from "@mui/material/IconButton";
import Swal from "sweetalert2";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { CategoryImage } from "../../components/CategoryImage/index";
import Avatar from "@mui/material/Avatar";
import { generateFileUrl } from "../../requestMethods";
import CustomGrid from "../../components/grid/CustomGrid";
import RowInput from "../../components/grid/RowInput";
import {
  selectSubCategories,
  validateNewSubCategory,
} from "../../util/categorySelection";

export default function CategoryList() {
  const currentUser = useSelector((state) => state.user.currentUser);
  const [isLoading, setIsLoading] = useState(false);
  const { companyId, isRetail } = useCompany();
  const [parentId, setParentId] = useState(null);
  const [category, setCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [inputs, setInputs] = useState({});
  const [file, setFile] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [nameCat, setNameCat] = useState();
  const [weight, setWeight] = useState();
  const [height, setHeight] = useState();
  const [width, setWidth] = useState();
  const [length, setLength] = useState();
  const [subCategory, setSubCategory] = useState("");

  // A lista de sub categorias é derivada de `categories`: guardar um snapshot
  // fazia a lista sumir a cada refresh/clique e impedia editar a sub categoria.
  const subCategories = useMemo(
    () => selectSubCategories(categories, parentId),
    [categories, parentId],
  );

  useEffect(() => {
    setIsLoading(true);
    if (companyId > 0) {
      getCategories();
    }
    setIsLoading(false);
  }, [companyId]);

  const getCategories = async () => {
    const res = await userRequest.get(`${companyId}/products/categories`);
    setCategories(res.data);
  };

  const handleChangeCat = (row) => {
    setCategory(row.id);
    setIsEdit(true);
    setNameCat(row.label || "");
    setWeight(row.weight ?? "");
    setHeight(row.height ?? "");
    setWidth(row.width ?? "");
    setLength(row.length ?? "");
    setFile(row.categoryImage || undefined);
    setParentId(row.id);
  };

  const handleNewCategory = () => {
    setCategory("");
    setIsEdit(false);
    setNameCat("");
    setWeight("");
    setHeight("");
    setWidth("");
    setLength("");
    setFile(undefined);
    setParentId(null);
  };
  const uploadImgCategory = async (categoryId) => {
    const formData = new FormData();
    formData.append("file", file);
    const res = await userRequest.post(
      `${companyId}/products/categories/${categoryId}`,
      formData,
    );

    if (res.status === 200) {
      return {
        success: true,
        imgUrl: res.data.imageUrls.newName,
      };
    } else {
      return {
        success: false,
      };
    }
  };
  const addCategory = async () => {
    let valida = false;
    if (
      weight !== "" &&
      weight !== undefined &&
      height !== "" &&
      height !== undefined &&
      width !== "" &&
      width !== undefined &&
      length !== "" &&
      length !== undefined
    ) {
      valida = true;
    }
    if (!valida) {
      if (
        (weight === "" || weight === undefined) &&
        (height === "" || height === undefined) &&
        (width === "" || width === undefined) &&
        (length === "" || length === undefined)
      ) {
        valida = true;
      } else {
        Swal.fire(
          "Atenção!",
          "Os campos Peso, Altura, Largura, Comprimento devem ser preenchidos.",
          "warning",
        );
      }
    }
    if (valida) {
      if (nameCat !== "" && nameCat !== undefined) {
        let cat = categories.find(
          (item) => item.label === nameCat.toString().toUpperCase(),
        );
        if (!cat) {
          const res = await userRequest.post(
            `${companyId}/products/categories/`,
            {
              label: nameCat,
              weight: weight,
              height: height,
              width: width,
              length: length,
              lastUserUpdate: currentUser.userId,
            },
          );
          if (file && res.data && res.data.categoryId) {
            const successUpload = await uploadImgCategory(res.data.categoryId);

            returnMsgImg(successUpload);
          } else {
            if (Object.keys(res.data).length > 0) {
              Swal.fire(
                "Parabéns!",
                "Categoria criada com sucesso!",
                "success",
              );
              getCategories();
            }
          }
        } else {
          Swal.fire("Atenção!", "Categoria existente!", "warning");
        }
      } else {
        Swal.fire(
          "Atenção!",
          "O campo Categoria deve ser preenchido.",
          "warning",
        );
      }
    }
  };
  function returnMsgImg(successUpload) {
    if (successUpload.success) {
      if (isEdit) {
        Swal.fire("Parabéns!", "Imagem alterada com sucesso!", "success");
      } else {
        Swal.fire("Parabéns!", "Categoria criada com sucesso!", "success");
      }

      getCategories();
    } else {
      Swal.fire("Atenção!", "Erro ao adicionar imagem à categoria", "error");
    }
  }
  const addSubCategory = async () => {
    const valida = validateNewSubCategory(parentId, subCategory, subCategories);

    if (!valida.ok) {
      Swal.fire("Atenção!", valida.msg, "warning");

      return;
    }

    const res = await userRequest.post(`${companyId}/products/categories/`, {
      label: subCategory,
      parentCategoryId: parentId,
      lastUserUpdate: currentUser.userId,
    });

    if (Object.keys(res.data).length > 0) {
      Swal.fire("Parabéns!", "Sub Categoria criada com sucesso!", "success");
      getCategories();
      setSubCategory("");
    }
  };
  const handleChange = (e) => {
    if (e.target.name === "category") {
      setNameCat(e.target.value);
    }
    if (e.target.name === "weight") {
      setWeight(e.target.value);
    }
    if (e.target.name === "height") {
      setHeight(e.target.value);
    }
    if (e.target.name === "width") {
      setWidth(e.target.value);
    }
    if (e.target.name === "length") {
      setLength(e.target.value);
    }
    if (e.target.name === "subcategory") {
      setSubCategory(e.target.value);
    }
    // setInputs((prev) => {
    //   return { ...prev, [e.target.name]: e.target.value };
    // });
  };

  const onButtonOffClick = async (e, categoryId) => {
    if (currentUser.isAdmin) {
      const res = await userRequest.put(
        `${companyId}/products/categories/logicaldelete/${categoryId}`,
        { deleted: new Date(), lastUserUpdate: currentUser.userId },
      );

      if (Object.keys(res.data).length > 0) {
        getCategories();
      } else {
        Swal.fire("Atenção!", "Erro ao desabilitar categoria!", "error");
      }
    } else {
      Swal.fire(
        "Atenção!",
        "Você não tem permissão para editar a categoria!",
        "warning",
      );
    }
  };
  const onButtonOnClick = async (e, categoryId) => {
    if (currentUser.isAdmin) {
      const res = await userRequest.put(
        `${companyId}/products/categories/logicaldelete/${categoryId}`,
        { deleted: null, lastUserUpdate: currentUser.userId },
      );

      if (Object.keys(res.data).length > 0) {
        getCategories();
      } else {
        Swal.fire("Atenção!", "Erro ao desabilitar categoria!", "error");
      }
    } else {
      Swal.fire(
        "Atenção!",
        "Você não tem permissão para editar a categoria!",
        "warning",
      );
    }
  };
  const columns = [
    {
      field: "id",
      type: "number",
      headerName: "Id",
      width: 50,
      align: "center",
      headerAlign: "center",
      clickable: true,
    },
    {
      field: "deleted",
      type: "date",
      headerName: "",
      width: 50,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        if (params.row.deleted === null || params.row.deleted === null) {
          return (
            <IconButton onClick={(e) => onButtonOffClick(e, params.row.id)}>
              <VisibilityOutlinedIcon />
            </IconButton>
          );
        } else {
          return (
            <IconButton onClick={(e) => onButtonOnClick(e, params.row.id)}>
              <VisibilityOffOutlinedIcon />
            </IconButton>
          );
        }
      },
    },
    {
      field: "categoryImage",
      type: "text",
      headerName: "Foto",
      clickable: true,
      align: "center",
      headerAlign: "center",
      width: 50,
      renderCell: (params) => {
        return (
          <>
            <Avatar
              sx={{ width: "30px", height: "30px" }}
              src={generateFileUrl(params.value)}
            />
          </>
        );
      },
    },
    {
      field: "label",
      type: "text",
      headerName: "Categoria",
      width: 200,
      align: "left",
      headerAlign: "left",
      editable: true,
      renderCell: ({ row }) => (
        <RowInput
          value={row.label}
          rowId={row.id}
          onBlur={(id, newValue) => {
            updateAlterarLabel(id, { label: newValue });
          }}
        />
      ),
    },
    {
      field: "weight",
      type: "number",
      headerName: "Peso(g)",
      width: 60,
      align: "center",
      headerAlign: "center",
      editable: true,
      renderCell: ({ row }) => (
        <RowInput
          value={row.weight}
          rowId={row.id}
          onBlur={(id, newValue) => {
            updateAlterarLabel(id, { weight: newValue });
          }}
        />
      ),
    },
    {
      field: "height",
      type: "number",
      headerName: "Altura(cm)",
      width: 60,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => (
        <RowInput
          value={row.height}
          rowId={row.id}
          onBlur={(id, newValue) => {
            updateAlterarLabel(id, { height: newValue });
          }}
        />
      ),
    },
    {
      field: "width",
      type: "number",
      headerName: "Largura(cm)",
      width: 60,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => (
        <RowInput
          value={row.width}
          rowId={row.id}
          onBlur={(id, newValue) => {
            updateAlterarLabel(id, { width: newValue });
          }}
        />
      ),
    },
    {
      field: "length",
      type: "number",
      headerName: "Comprimento(cm)",
      width: 60,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => (
        <RowInput
          value={row.length}
          rowId={row.id}
          onBlur={(id, newValue) => {
            updateAlterarLabel(id, { length: newValue });
          }}
        />
      ),
    },
  ];
  const columnsSub = [
    {
      field: "deleted",
      type: "date",
      headerName: "",
      width: 50,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        if (params.row.deleted === null || params.row.deleted === null) {
          return (
            <IconButton onClick={(e) => onButtonOffClick(e, params.row.id)}>
              <VisibilityOutlinedIcon />
            </IconButton>
          );
        } else {
          return (
            <IconButton onClick={(e) => onButtonOnClick(e, params.row.id)}>
              <VisibilityOffOutlinedIcon />
            </IconButton>
          );
        }
      },
    },
    {
      field: "id",
      type: "number",
      headerName: "Id",
      width: 50,
      align: "center",
      headerAlign: "center",
      clickable: true,
    },
    {
      field: "label",
      type: "text",
      headerName: "Categoria",
      width: 300,
      align: "left",
      headerAlign: "left",
      editable: true,
      renderCell: ({ row }) => (
        <RowInput
          value={row.label}
          rowId={row.id}
          onBlur={(id, newValue) => {
            updateAlterarLabel(id, { label: newValue });
          }}
        />
      ),
    },
  ];
  async function updateAlterarLabel(id, obj) {
    if (currentUser.isAdmin) {
      const res = await userRequest.put(
        `${companyId}/products/categories/${id}`,
        { ...obj, lastUserUpdate: currentUser.userId },
      );

      if (Object.keys(res.data).length > 0) {
        Swal.fire("Parabéns!", "Categoria alterada com sucesso!", "success");
        getCategories();
      }
    } else {
      Swal.fire(
        "Atenção!",
        "Você não tem permissão para editar a categoria!",
        "warning",
      );
    }
  }

  async function updateImage() {
    const successUpload = await uploadImgCategory(category);
    returnMsgImg(successUpload);
  }

  const toInt = (v) => (v === "" || v === undefined ? null : Number(v));

  async function updateCategory() {
    const res = await userRequest.put(
      `${companyId}/products/categories/${category}`,
      {
        label: nameCat,
        weight: toInt(weight),
        height: toInt(height),
        width: toInt(width),
        length: toInt(length),
        lastUserUpdate: currentUser.userId,
      },
    );

    if (file && file.name) {
      const successUpload = await uploadImgCategory(category);
      returnMsgImg(successUpload);
    } else if (Object.keys(res.data).length > 0) {
      Swal.fire("Parabéns!", "Categoria alterada com sucesso!", "success");
      getCategories();
    }
  }
  return (
    <div className="cust-page">
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <div className="cust-title">Categorias</div>

          {/* Nova / Editar categoria */}
          <div className="cust-card">
            <div className="cust-section-header">
              {isEdit ? `Editar Categoria (ID: ${category})` : "Nova Categoria"}
            </div>
            <div className="cust-fields cust-fields-3">
              <div className="cust-field">
                <label className="cust-label">Nome Categoria</label>
                <input
                  className="cust-input"
                  type="text"
                  name="category"
                  onChange={handleChange}
                  value={nameCat || ""}
                />
              </div>
              <div className="cust-field">
                <label className="cust-label">Peso (g)</label>
                <input
                  className="cust-input"
                  type="number"
                  name="weight"
                  onChange={handleChange}
                  maxLength="100"
                  value={weight ?? ""}
                />
              </div>
              <div className="cust-field">
                <label className="cust-label">Altura (cm)</label>
                <input
                  className="cust-input"
                  type="number"
                  name="height"
                  onChange={handleChange}
                  maxLength="100"
                  value={height ?? ""}
                />
              </div>
              <div className="cust-field">
                <label className="cust-label">Largura (cm)</label>
                <input
                  className="cust-input"
                  type="number"
                  name="width"
                  onChange={handleChange}
                  maxLength="100"
                  value={width ?? ""}
                />
              </div>
              <div className="cust-field">
                <label className="cust-label">Comprimento (cm)</label>
                <input
                  className="cust-input"
                  type="number"
                  name="length"
                  onChange={handleChange}
                  maxLength="100"
                  value={length ?? ""}
                />
              </div>
            </div>
            <div style={{ padding: "0 16px 16px" }}>
              <CategoryImage
                file={file}
                setFile={setFile}
                isEdit={isEdit}
                setIsEdit={setIsEdit}
                categoryId={category}
              />
            </div>
            <div style={{ padding: "0 16px 16px", display: "flex", gap: "8px" }}>
              {isEdit ? (
                <>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    startIcon={<SaveIcon />}
                    onClick={updateCategory}
                  >
                    Salvar Alterações
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleNewCategory}
                  >
                    Nova Categoria
                  </Button>
                </>
              ) : (
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  startIcon={<SaveIcon />}
                  onClick={addCategory}
                >
                  Adicionar Categoria
                </Button>
              )}
            </div>
          </div>

          {/* Lista categorias */}
          <div className="cust-card">
            <div className="cust-section-header">Categorias Cadastradas</div>
            <div style={{ padding: "16px" }}>
              <CustomGrid
                gridId="catList"
                rows={categories}
                columns={columns}
                pageSize={10}
                checkboxSelection={false}
                onRowClick={(row) => handleChangeCat(row)}
              />
            </div>
          </div>

          {/* Sub categorias */}
          <div className="cust-card">
            <div className="cust-section-header">Nova Sub Categoria</div>
            <div className="cust-fields">
              <div className="cust-field">
                <label className="cust-label">Nome Sub Categoria</label>
                <input
                  className="cust-input"
                  type="text"
                  name="subcategory"
                  onChange={handleChange}
                  maxLength="100"
                  value={subCategory}
                />
              </div>
            </div>
            <div style={{ padding: "0 16px 16px" }}>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                startIcon={<SaveIcon />}
                onClick={addSubCategory}
              >
                Adicionar Sub Categoria
              </Button>
            </div>
          </div>

          <div className="cust-card">
            <div className="cust-section-header">
              Sub Categorias Cadastradas
            </div>
            <div style={{ padding: "16px" }}>
              <CustomGrid
                gridId="subCatList"
                rows={subCategories}
                columns={columnsSub}
                pageSize={10}
                checkboxSelection={false}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}
